// import { useCallback } from "react";
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
// import type { LiveGiftsAnimations } from "../../../types/lives/animations";
import type { NotifyGift } from '../../../types/lives/notifies'

const LIVE_GIFTS_SENTS = '/LIVE-GIFTS-SENTS'

export const useUpdateGiftReturnLuck = () => {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))
  const liveCountry = useGlobalStore(useShallow((state) => state.liveCountry))

  const addNotifyGiftSentReturnList = useGlobalStore(
    useShallow((state) => {
      return state.addNotifyGiftSentReturnList
    }),
  )

  const notifies = (notifyGiftSent: NotifyGift) => {
    // const topGlobal = notifyGiftSent?.message?.topGlobal
    // const topSameCountry = notifyGiftSent?.message?.topSameCountry
    // const topLocal = notifyGiftSent?.message?.topLocal

    const middle = notifyGiftSent?.message?.middle
    // const chat = notifyGiftSent?.message?.chat

    if (middle) {
      addNotifyGiftSentReturnList({
        ...middle,
        id: `${Date.now()}`,
      })
    }

    // if (chat) {
    //   notifyChat(chat)
    // }

    // if (topGlobal) {
    //   return notifyToastGlobal(topGlobal, notifyGiftSent)
    // }

    // if (topSameCountry) {
    //   return notifyToastSameCountry(topSameCountry, notifyGiftSent)
    // }

    // if (topLocal) {
    //   notifyToastLocal(topLocal, notifyGiftSent)
    // }
  }

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/all`,
    skip: !liveId,
    // onData: notifies,
    onData: notifies,
  })

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/${liveCountry}`,
    skip: !liveCountry,
    onData: notifies,
  })

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/${liveId}`,
    skip: !liveId,
    onData: notifies,
  })
}
